import { render } from "./MenuAdmin.vue?vue&type=template&id=4460e6d4&scoped=true"
import script from "./MenuAdmin.vue?vue&type=script&lang=js"
export * from "./MenuAdmin.vue?vue&type=script&lang=js"

import "./_main-menu.scss?vue&type=style&index=0&id=4460e6d4&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4460e6d4"]])

export default __exports__